import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  DEFAULT_DRILL_FILTERS,
  FilterStateDrill,
  UpdateDrillFiltersPayload,
} from "./types";

const initialState: FilterStateDrill = {
  porRemarcacao: {},
};

const drillFilterSlice = createSlice({
  name: "drillFilter",
  initialState,
  reducers: {
    updateDrillFilters(
      state,
      action: PayloadAction<UpdateDrillFiltersPayload>,
    ): void {
      const { markdownId, group, value } = action.payload;
      const current =
        state.porRemarcacao[markdownId] ?? DEFAULT_DRILL_FILTERS;
      state.porRemarcacao[markdownId] = { ...current, [group]: value };
    },
    migrateDrillFilters(
      state,
      action: PayloadAction<{ from: string; to: string }>,
    ) {
      const { from, to } = action.payload;
      if (from === to) return;
      const entry = state.porRemarcacao[from];
      if (!entry) return;
      state.porRemarcacao[to] = entry;
      delete state.porRemarcacao[from];
    },
    resetDrillFilters(state, action: PayloadAction<string>) {
      delete state.porRemarcacao[action.payload];
    },
  },
});

export const { updateDrillFilters, migrateDrillFilters, resetDrillFilters } =
  drillFilterSlice.actions;
export default drillFilterSlice.reducer;
